import { ArrowRight } from "lucide-react";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-32 md:pt-40 pb-20 md:pb-32 overflow-hidden grain"
    >
      <div className="mx-auto max-w-4xl px-6 md:px-10 flex flex-col items-center text-center">
        <div className="flex items-center justify-center gap-3 mb-6">
          <span className="h-px w-12 bg-[#C05C46]/60" />
          <span className="overline">Wellness Beyond Relief</span>
          <span className="h-px w-12 bg-[#C05C46]/60" />
        </div>

        <h1
          data-testid="hero-title"
          className="font-serif-display text-5xl sm:text-6xl md:text-7xl leading-[0.95] tracking-tight text-[#2E3A2F]"
        >
          A quieter body.
          <br />
          A brighter mind.
          <br />
          <span className="italic text-[#C05C46]">Ayurvedauniversal</span> found within.
        </h1>

        <p
          data-testid="hero-subtitle"
          className="mt-8 max-w-xl text-base md:text-lg leading-relaxed text-[#5C6B5D]"
        >
          <span className="font-medium text-[#2E3A2F]">Ayurvedauniversal</span> is a
          slow, honest return to Ayurveda
        </p>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <a
            href="#products"
            data-testid="hero-cta-explore"
            className="btn-primary"
          >
            Explore Remedies <ArrowRight className="h-4 w-4" strokeWidth={1.5} />
          </a>
          <a href="#story" data-testid="hero-cta-story" className="btn-ghost">
            Our Story
          </a>
        </div>

        <div className="mt-14 flex items-center justify-center gap-8">
          <Stat label="Herbs sourced" value="120+" />
          <span className="h-8 w-px bg-[#DCD3C6]" />
          <Stat label="Years of tradition" value="5000" />
          <span className="h-8 w-px bg-[#DCD3C6]" />
          <Stat label="Lives touched" value="40k" />
        </div>
      </div>
    </section>
  );
}

function Stat({ label, value }) {
  return (
    <div>
      <div className="font-serif-display text-3xl md:text-4xl text-[#2E3A2F]">
        {value}
      </div>
      <div className="overline mt-1">{label}</div>
    </div>
  );
}
